import React, { useEffect, useState } from 'react';
import { Calendar, RefreshCw } from 'lucide-react';
import { SlotCard, ContentSlot } from '../../components/admin/SlotCard';

export const HarmonogramPage: React.FC = () => {
    const [slots, setSlots] = useState<ContentSlot[]>([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        fetch('/api/admin/content?status=approved,published,failed&limit=200', { credentials: 'include' })
            .then(r => r.json())
            .then(d => setSlots((d.slots || []).sort((a: ContentSlot, b: ContentSlot) =>
                (a.scheduled_at || '').localeCompare(b.scheduled_at || '')
            )))
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    // Group by day
    const byDay: Record<string, ContentSlot[]> = {};
    for (const s of slots) {
        const day = (s.scheduled_at || s.created_at).slice(0, 10);
        (byDay[day] = byDay[day] || []).push(s);
    }
    const days = Object.keys(byDay).sort();

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-bold">Harmonogram ({slots.length} slotów)</h1>
                <button onClick={load} className="px-3 py-2 bg-bkg-light dark:bg-bkg-dark rounded-md flex items-center gap-2 text-sm">
                    <RefreshCw className="w-4 h-4" /> Odśwież
                </button>
            </div>

            {loading && <div className="text-sm">Ładowanie…</div>}

            {!loading && slots.length === 0 && (
                <div className="bg-white dark:bg-content-dark rounded-xl border border-border-light dark:border-border-dark p-8 text-center">
                    <Calendar className="w-10 h-10 mx-auto mb-3 text-text-secondary-light dark:text-text-secondary-dark" />
                    <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
                        Brak zatwierdzonych slotów. Wejdź w <strong>Propozycje postów</strong> i zatwierdź propozycje.
                        Cron publisher (co 5 min) opublikuje sloty z <code>scheduled_at</code> minęło.
                    </p>
                </div>
            )}

            {days.map(day => (
                <div key={day} className="mb-6">
                    <h2 className="font-semibold text-sm mb-3 text-text-secondary-light dark:text-text-secondary-dark">
                        {new Date(day).toLocaleDateString('pl-PL', { weekday: 'long', day: 'numeric', month: 'long' })}
                        <span className="ml-2 text-xs">({byDay[day].length})</span>
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                        {byDay[day].map(s => (
                            <SlotCard
                                key={s.id}
                                slot={s}
                                onAction={(_, updated) => setSlots(slots.map(x => x.id === s.id ? updated : x))}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
